import { updateUnitInfo } from "@/service/unit";
export default {
  name: "UpdateUnitPhone",
  props: {
    visible: {
      type: Boolean,
      default() {
        return false;
      }
    },
    item: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      modal: {
        visible: false,
        loading: false
      },
      formObj: {
        switchboardNumber: ""
      },
      ruleCustom: {
        switchboardNumber: [{
          /*eslint-disable*/
          pattern: /^[0-9\-]{1,32}$/,
          message: $t("r085bef", "联系电话由1-32位的纯数字和") + "-" + $t("m3m42", "组成")
        }]
      }
    };
  },
  watch: {
    visible(val) {
      val && this.init();
      this.modal.visible = val;
    }
  },
  methods: {
    /* 不显示弹窗 */
    clean() {
      this.$emit("close");
      this.$refs["formCustom"].resetFields();
      this.formObj.switchboardNumber = "";
    },
    init() {
      this.formObj.switchboardNumber = this.item.switchboardNumber;
    },
    /* 提交事件 */
    onCommit() {
      /* 验证 */
      this.$refs["formCustom"].validate(async valid => {
        if (valid) {
          this.modal.loading = true;
          const params = {
            switchboardNumber: this.formObj.switchboardNumber
          };
          let res = await updateUnitInfo(params);
          if (res.data && res.data.result === 0) {
            this.$Message.success($t("d1spvi4", "操作成功"));
            this.$emit("update");
            this.clean();
          }
          this.modal.loading = false;
        }
      });
    }
  }
};